import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAppraisalData } from "../../../store/selectors";
import { appraisalSlice } from "../../../store/slices/Appraisal";
import { useSourceSystem } from "../../../hooks/useSourceSystem";
import { TransientError } from "../TransientError/TransientError";
import Error from "./Error";

export default function ErrorContainer() {
  const dispatch = useDispatch();
  const { isOnline } = useSelector(getAppraisalData);
  const {
    sourceSystem: { useTransientErrorComponent }
  } = useSourceSystem();

  useEffect(() => {
    if (!isOnline) dispatch(appraisalSlice.actions.setIsOnline(true));
  }, [dispatch, isOnline]);

  return <>{useTransientErrorComponent ? <TransientError /> : <Error />}</>;
}
